export default __webpack_public_path__ + "static/media/default.4dd6999467a71f7ade94654cb87beec6.png";